import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_verifone_point_cloud_event.js";
//#region src/bite_log_verifone_point_cloud_event_helper.ts
var bite_log_verifone_point_cloud_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 5: return "terminal-disconnected";
	}
}
//#endregion
export { bite_log_verifone_point_cloud_event_helper_exports, name };

//# sourceMappingURL=bite_log_verifone_point_cloud_event_helper.js.map